import { useIsOnboardingRedesign } from './useIsOnboardingRedesign'
import { useIsPioneerStarterOrGrowth } from './useIsPioneerStarterOrGrowth'

export const useIsVisualStylesOnboarding = () => {
  const isOnboardingRedesign = useIsOnboardingRedesign()
  const planVariant = useIsPioneerStarterOrGrowth()
  const isStarterOrGrowth = ['starter', 'growth'].includes(planVariant)

  return isOnboardingRedesign && isStarterOrGrowth
}
